import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../api/client';

const initialState = {
    status: 'idle',
    error: null,
    userPosition: {lat: 42.6101, lng: 12.46459}
};


const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setUserPosition(state, action) {
            state.userPosition = action.payload;
        }
    }
});

export default mapSlice.reducer;
    
export const selectUserPosition = (state) => state.map.userPosition;
export const { setUserPosition } = mapSlice.actions;